// react
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// material-ui components
import TextField from '@material-ui/core/TextField';
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Select from 'react-select';
import {ValidSelect} from "beaktShared/helpers/validselect";
import {MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbersStart1,MaskOnlyNumbers} from "beaktShared/helpers/masks";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/pagamentoCartao.js";
const useStyles = makeStyles(styles);

export default function PedidoCompraPagamentoCartao({ pgto, CallloadTotalizadorPgtos }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);
  const { register, errors, getValues, handleSubmit, setValue, clearError, setError} = useForm({mode: "onBlur"});   

  const [messageReturn,setmessageReturn]= React.useState({
    show:false,
    message:''
  });

  const [bandeira, setbandeira] = React.useState("");
  const [listSelectBandeiras, setlistSelectBandeiras] = React.useState([]);  

  const LoadSelectBandeiras = (s) =>{  
    const endPoint = "cartaoBandeira/"
    UseGetApiSimple(endPoint,0).then(result=>{       
        if(result.status !== 200)
        {                                     
            //showNotification(result.message,'danger');
            //return false; 
        }      
             
        if(result.data !== undefined)
          setlistSelectBandeiras(result.data);
        return true;                
    });  
  };  

  const [detalheParcela,setdetalheParcela]= React.useState({
    show:false,
    valorParcela:0
  });  

  useEffect(() => {  
    LoadSelectBandeiras();
  }, []);

  const handleChangeParcelas = (e) =>{
    let qtd = parseInt(e.target.value);
    let valor = getValues().valor;
    calculaValorParcela(qtd,valor);
  }

  const handleChangeValor = (e) =>{
    let valor = e.target.value;
    let qtd = parseInt(getValues().parcelas);
    calculaValorParcela(qtd,valor);
  }

  const calculaValorParcela = (qtd,valor) =>{

    if(valor === "" || valor === undefined)
    {
      setdetalheParcela({show:false,valorParcela:0})
      return;
    }
      
    if(qtd === 1)
    {   
      setdetalheParcela({show:false,valorParcela:0})
      return;
    }     

    valor = transformValueFormatedtoFloat(valor);
    if(valor === 0)
    {
      setdetalheParcela({show:false,valorParcela:0})
      return;
    }

    let valorParcela = valor / qtd;      
    setdetalheParcela({show:true,valorParcela:valorParcela})
    return;
    
  }

  const handleNomeCartao = (e) =>{    
    e.target.value = e.target.value.toUpperCase();
  }

  const [LoadingForm,setLoadingForm]= React.useState(false);
  
  const validateMoth = (m) =>{

    if (m === '01' || m === '02' || m === '03' || m === '04' || m === '05' || m === '06' ||
        m === '07' || m === '08' || m === '09' || m === '10' || m === '11' || m === '12'  )
    {
        return true;              
    }
    return false;  
  }

  const clearForm = () =>{
    setValue("numcartao","");
    setValue("nomecartao","");
    setValue("validademes","");
    setValue("validadeano","");
    setValue("cvv","");
    setValue("valor","");
    setValue("parcelas",1);
    setValue("bandeira","");
    setbandeira("");
    setdetalheParcela({show:false,valorParcela:0})
  }

  const getCodEsitefByIdCartaoBandeira = () =>{
    var vefifyExists = listSelectBandeiras.filter(obj => {
      return obj.cartaoBandeiraId === bandeira;
    });
    if(vefifyExists[0])
      return vefifyExists[0].codigoBandeiraEsitef;  
  }

  const handleBandeiraChange = event => {
    let value = event
    setbandeira(value);
    setValue("bandeira", value);  
    if (value !== "") 
        clearError("bandeira"); 
  }; 

  const onSubmit = (data, e) => {
    e.preventDefault();
        
    setLoadingForm(true);
       
    let codBandeira = 0;
    let numFinalCartao = "";
    
    if (data.bandeira === null){
    return setError("bandeira", "required");
    }
    if(data.numcartao.length < 16)
    {
    setmessageReturn({
        show:true,
        message:t('error_message.invalid_card_number')
    });    
    setLoadingForm(false);  
    return false;
    }

    if(!validateMoth(data.validademes))
    {
    setmessageReturn({
        show:true,
        message:t('error_message.invalid_month_validity')
    });    
    setLoadingForm(false);  
    return false;
    }

    let now = new Date();
    let data_cartao = new Date(parseInt("20" + data.validadeano), parseInt(data.validademes) - 1, 1);
    if (data_cartao < new Date(now.getFullYear(), now.getMonth(), 1)){
    setmessageReturn({
        show:true,
        message:t('error_message.card_expired')
    });    
    setLoadingForm(false);  
    return false;
    }

    codBandeira = getCodEsitefByIdCartaoBandeira();
    if(codBandeira === undefined || codBandeira === null)
    {
    setmessageReturn({
        show:true,
        message:t('error_message.select_card_flag')
    });    
    setLoadingForm(false);  
    return false;
    }

    numFinalCartao = data.numcartao.substring(12,16);  
    
    let valor = transformValueFormatedtoFloat(data.valor);
    if(valor > pgto.totalizadorPagamentos.valorPendente)
    {
      setmessageReturn({
        show:true,
        message:t('error_message.the_amount_must_be_equal_or_less_than_the_balance_to_pay')
      });    
      setLoadingForm(false);  
      return false;
    }
    
    let descParcelas =t('label.at_sight');
    if(parseInt(data.parcelas) > 1)
        descParcelas = data.parcelas + "x "+transformValueFloattoFormated(detalheParcela.valorParcela);
      
    let pg = {
      id:pgto.pedidoCOmpraPagamentoCartoes.length+1,      
      valor:valor,
      descTipo: "Beakt Crédito ESitef final " + numFinalCartao,
      parcelas:data.parcelas,
      descPacela:descParcelas,
      ultimosQuatroDigitos: numFinalCartao,
      bandeira: bandeira,
      numCartao: data.numcartao,
      nomeCartao: data.nomecartao,        
      dataVencCartao: data.validademes + data.validadeano,
      codSegurancaCartao: data.cvv,
      codBandeiraCartao:codBandeira
    }

    let updatepgto ={
      ...pgto,        
      pedidoCOmpraPagamentoCartoes:[
        ...pgto.pedidoCOmpraPagamentoCartoes,
        pg
      ]
    };

    clearForm();
    setmessageReturn({show:false})
    setLoadingForm(false);  
    CallloadTotalizadorPgtos(updatepgto);   
    return true;
  }

return (
    <div>    
      
      <form onSubmit={handleSubmit(onSubmit)}>   
            
        <GridContainer className={classes.containerin}> 
          <GridItem xs={12} sm={3} md={4}>
            <div className={classes.labelIdent}>
             {t('label.flag')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={9} md={6}>
            <Select
              classNamePrefix="select"
              styles={ValidSelect(errors.bandeira?true:false)}
              isSearchable={true}
              name="bandeira"
              placeholder={t('label.select')+"..."}
              options={listSelectBandeiras}              
              getOptionLabel={({descricao}) => descricao}
              getOptionValue={({cartaoBandeiraId}) => cartaoBandeiraId}
              onChange={(value) => handleBandeiraChange(value.cartaoBandeiraId !== null ? value.cartaoBandeiraId : "") }              
              ref={() => register({ name: "bandeira" },{ required: false })}
            />
            <FormHelperText className={classes.labelRootError}>
              {errors.bandeira && <span className="obg">{t('label.required')}</span>}
            </FormHelperText> 
          </GridItem>
        </GridContainer>            
      
          <GridContainer className={classes.containerin}> 
            <GridItem xs={12} sm={3} md={4}>
              <div className={classes.labelIdent}>
              {t('label.card_number')} *
              </div>
            </GridItem>
            <GridItem xs={12} sm={9} md={6}>
                <TextField
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{shrink: true}} 
                    defaultValue=""  
                    name="numcartao"      
                    inputProps={{maxLength: 16}}   
                    onInput={(e) => MaskOnlyNumbers(e) }             
                    inputRef={register({required: true})}
                    error={errors.numcartao?true:false} 
                />
                <FormHelperText>
                    {errors.numcartao && <span className="obg">{t('label.required')}</span>}
                </FormHelperText>   
            </GridItem>
          </GridContainer>
                
          <GridContainer className={classes.containerin}>
            <GridItem xs={12} sm={3} md={4}>
              <div className={classes.labelIdent}>
              {t('label.card_name')} *
              </div>
            </GridItem>
            <GridItem xs={12} sm={9} md={6}>
                <TextField
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{shrink: true}} 
                    defaultValue=""  
                    name="nomecartao" 
                    onChange={(e) => handleNomeCartao(e)}  
                    inputProps={{maxLength: 30}}              
                    inputRef={register({required: true})}
                    error={errors.nomecartao?true:false} 
                />
                <FormHelperText>
                    {errors.nomecartao && <span className="obg">{t('label.required')}</span>}
                </FormHelperText>   
            </GridItem>
          </GridContainer>
                        
          <GridContainer className={classes.containerin}>
            <GridItem xs={12} sm={3} md={4}>
              <div className={classes.labelIdent}>
              {t('label.validity')} *
              </div>
            </GridItem>
            <GridItem xs={12} sm={4} md={3}>
                <TextField
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{shrink: true}} 
                    defaultValue="" 
                    placeholder={t('label.month')}  
                    name="validademes"   
                    inputProps={{maxLength: 2}}   
                    onInput={(e) => MaskOnlyNumbers(e) }                
                    inputRef={register({required: true})}
                    error={errors.validademes?true:false} 
                />
                <FormHelperText>
                    {errors.validademes && <span className="obg">{t('label.required')}</span>}
                </FormHelperText>   
            </GridItem>
            <GridItem xs={12} sm={4} md={3}>
                <TextField
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{shrink: true}} 
                    defaultValue="" 
                    placeholder={t('label.year')} 
                    name="validadeano"   
                    inputProps={{maxLength: 2}}   
                    onInput={(e) => MaskOnlyNumbers(e) }                
                    inputRef={register({required: true})}
                    error={errors.validadeano?true:false} 
                />
                <FormHelperText>
                    {errors.validadeano && <span className="obg">{t('label.required')}</span>}
                </FormHelperText>   
            </GridItem>
          </GridContainer>          
        
          <GridContainer className={classes.containerin}>
          <GridItem xs={12} sm={3} md={4}>
            <div className={classes.labelIdent}>
            {t('label.cvv')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={3} md={2}>
              <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{shrink: true}} 
                  defaultValue="" 
                  name="cvv"       
                  inputProps={{maxLength: 3}}   
                  onInput={(e) => MaskOnlyNumbers(e) }               
                  inputRef={register({required: true})}
                  error={errors.cvv?true:false} 
              />
              <FormHelperText>
                  {errors.cvv && <span className="obg">{t('label.required')}</span>}
              </FormHelperText>   
          </GridItem>        
        </GridContainer>         
      <GridContainer className={classes.containerin}>
        <GridItem xs={12} sm={3} md={4}>
          <div className={classes.labelIdent}>
          {t('label.value')} *
          </div>
        </GridItem>
        <GridItem xs={12} sm={4} md={3}>  
            <TextField
                fullWidth
                variant="outlined"
                InputLabelProps={{shrink: true}} 
                defaultValue=""  
                name="valor"        
                onChange={(e) => handleChangeValor(e)}          
                InputProps={{ inputComponent: MaskMoney}}    
                inputRef={register({required: true})}
                error={errors.valor?true:false} 
            />
            <FormHelperText>
                {errors.valor && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>   
        </GridItem>
      </GridContainer>
      
        <GridContainer className={classes.containerin}>
          <GridItem xs={12} sm={3} md={4}>
            <div className={classes.labelIdent}>
            {t('label.parcel_in')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={3} md={2}>
              <TextField
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{shrink: true}} 
                  name="parcelas"                  
                  defaultValue={1}      
                  type="number"     
                  onChange={(e) => handleChangeParcelas(e)}                                               
                  inputProps={{maxLength: 3}} 
                  onInput={(e) => MaskOnlyNumbersStart1(e) }          
                  inputRef={register({required: true})}
                  error={errors.parcelas?true:false} 
              />
              <FormHelperText>
                  {errors.parcelas && <span className="obg">{t('label.required')}</span>}
              </FormHelperText>   
          </GridItem>   
          <GridItem xs={12} sm={5} md={5}>
            <br/>
            <small>({t('information_message.inform_the_number_of_parcels')})</small>
          </GridItem>       
        </GridContainer> 
      
          
        <GridContainer className={classes.containerin}>
          <GridItem xs={12} sm={3} md={4}>
            <div className={classes.labelIdent}>       
            </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            {detalheParcela.show &&
              <div><div className={classes.boxTotalParcela}>
                <label className={classes.boxValueParcela}>
                {t('label.parcel_value')}: {t('label.money_symbol')} {transformValueFloattoFormated(detalheParcela.valorParcela)}
                </label> 
              </div><br/></div>
            }
          </GridItem>       
        </GridContainer>        

      <GridContainer className={classes.containerin}>
        <GridItem xs={12} sm={12} md={12}>
          {messageReturn.show &&
            <div><div className="alertErrorEx alertmax">
              <p>
              {messageReturn.message}   
              </p>
            </div><br/></div>
          }
            <center>
              <span className={classes.boxTotalPagamentoCt}>
              {t('label.total')} {t('label.money_symbol')}{transformValueFloattoFormated((getValues().valor === undefined || getValues().valor === "") ? 0 : getValues().valor)}                
            </span>
            <Button type="submit" color="primary" >
            {t('button.post_payment')}             
            </Button>
            {LoadingForm && <CircularProgress />}
            </center>
        </GridItem>
      </GridContainer>
      </form>

    </div>
);
}